export const WORKSPACES_RETRIEVE_REQUEST = 'WORKSPACES_RETRIEVE_REQUEST';
export const WORKSPACES_RETRIEVE_SUCCESS = 'WORKSPACES_RETRIEVE_SUCCESS';
export const WORKSPACES_RETRIEVE_FAILURE = 'WORKSPACES_RETRIEVE_FAILURE';

export const WORKSPACES_EDIT_REQUEST = 'WORKSPACES_EDIT_REQUEST';
export const WORKSPACES_EDIT_SUCCESS = 'WORKSPACES_EDIT_SUCCESS';
export const WORKSPACES_EDIT_FAILURE = 'WORKSPACES_EDIT_FAILURE';

export const WORKSPACES_CREATE_REQUEST = 'WORKSPACES_CREATE_REQUEST';
export const WORKSPACES_CREATE_SUCCESS = 'WORKSPACES_CREATE_SUCCESS';
export const WORKSPACES_CREATE_FAILURE = 'WORKSPACES_CREATE_FAILURE';

export const WORKSPACES_DELETE_REQUEST = 'WORKSPACES_DELETE_REQUEST';
export const WORKSPACES_DELETE_SUCCESS = 'WORKSPACES_DELETE_SUCCESS';
export const WORKSPACES_DELETE_FAILURE = 'WORKSPACES_DELETE_FAILURE';

export const WORKSPACES_ADD_TO_REQUEST = 'WORKSPACES_ADD_TO_REQUEST';
export const WORKSPACES_ADD_TO_SUCCESS = 'WORKSPACES_ADD_TO_SUCCESS';
export const WORKSPACES_ADD_TO_FAILURE = 'WORKSPACES_ADD_TO_FAILURE';

export const WORKSPACES_UNSUBSCRIBE_REQUEST = 'WORKSPACES_UNSUBSCRIBE_REQUEST';
export const WORKSPACES_UNSUBSCRIBE_SUCCESS = 'WORKSPACES_UNSUBSCRIBE_SUCCESS';
export const WORKSPACES_UNSUBSCRIBE_FAILURE = 'WORKSPACES_UNSUBSCRIBE_FAILURE';

export const WORKSPACES_DELETE_ALL_FROM_REQUEST = 'WORKSPACES_DELETE_ALL_FROM_REQUEST';
export const WORKSPACES_DELETE_ALL_FROM_SUCCESS = 'WORKSPACES_DELETE_ALL_FROM_SUCCESS';
export const WORKSPACES_DELETE_ALL_FROM_FAILURE = 'WORKSPACES_DELETE_ALL_FROM_FAILURE';

export const WORKSPACES_DELETE_FROM_REQUEST = 'WORKSPACES_DELETE_FROM_REQUEST';
export const WORKSPACES_DELETE_FROM_SUCCESS = 'WORKSPACES_DELETE_FROM_SUCCESS';
export const WORKSPACES_DELETE_FROM_FAILURE = 'WORKSPACES_DELETE_FROM_FAILURE';

export const WORKSPACES_CANCEL_ALL_REQUESTS = 'WORKSPACES_CANCEL_ALL_REQUESTS';
export const WORKSPACES_CANCEL_CREATE_REQUEST = 'WORKSPACES_CANCEL_CREATE_REQUEST';

export const WORKSPACES_RETRIEVE_INFO_REQUEST = 'WORKSPACES_RETRIEVE_INFO_REQUEST';
export const WORKSPACES_RETRIEVE_INFO_SUCCESS = 'WORKSPACES_RETRIEVE_INFO_SUCCESS';
export const WORKSPACES_RETRIEVE_INFO_FAILURE = 'WORKSPACES_RETRIEVE_INFO_FAILURE';

export const WORKSPACE_COLLAPSE = 'WORKSPACE_COLLAPSE';
export const WORKSPACE_LIST_CLEAR = 'WORKSPACE_LIST_CLEAR';
